import React from 'react';
import { Input } from '../../ui/input';
import CommonFormFields from './CommonFormFields';

/**
 * Local Pickup Form - Request pickup of items from a store or business
 */
const LocalPickupForm = ({ formData, setFormData }) => {
  const updateField = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-4">
      <CommonFormFields formData={formData} setFormData={setFormData} />
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Pickup Details</h4>
      
      <div>
        <label className="block text-sm font-medium mb-2">Business/Store Name</label>
        <Input
          value={formData.pickup_business_name || ''}
          onChange={(e) => updateField('pickup_business_name', e.target.value)}
          placeholder="e.g., Walmart, CVS, Restaurant Name"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Pickup Address *</label>
        <Input
          value={formData.pickup_address || ''}
          onChange={(e) => updateField('pickup_address', e.target.value)}
          placeholder="Full address"
          required
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2">Contact Name *</label>
          <Input
            value={formData.pickup_contact_name || ''}
            onChange={(e) => updateField('pickup_contact_name', e.target.value)}
            placeholder="Who to ask for"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Contact Phone *</label>
          <Input
            value={formData.pickup_contact_phone || ''}
            onChange={(e) => updateField('pickup_contact_phone', e.target.value)}
            placeholder="Store/pickup phone"
            required
          />
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Order/Reference Number</label>
        <Input
          value={formData.pickup_reference_number || ''}
          onChange={(e) => updateField('pickup_reference_number', e.target.value)}
          placeholder="Order #, confirmation code, etc."
        />
      </div>
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Item Details</h4>
      
      <div>
        <label className="block text-sm font-medium mb-2">Item Description *</label>
        <textarea
          value={formData.item_description || ''}
          onChange={(e) => updateField('item_description', e.target.value)}
          className="w-full p-3 border rounded-xl min-h-[80px]"
          placeholder="Describe what you need picked up"
          required
        />
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2">Quantity</label>
          <Input
            type="number"
            min="1"
            value={formData.item_quantity || 1}
            onChange={(e) => updateField('item_quantity', parseInt(e.target.value))}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Size</label>
          <select
            value={formData.item_size || 'medium'}
            onChange={(e) => updateField('item_size', e.target.value)}
            className="w-full p-3 border rounded-xl"
          >
            <option value="small">Small</option>
            <option value="medium">Medium</option>
            <option value="large">Large</option>
            <option value="oversized">Oversized (SUV)</option>
          </select>
        </div>
      </div>
      
      <div className="flex flex-wrap gap-4">
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={formData.is_prepaid || false}
            onChange={(e) => updateField('is_prepaid', e.target.checked)}
            className="w-4 h-4"
          />
          Already Paid For
        </label>
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={formData.is_fragile || false}
            onChange={(e) => updateField('is_fragile', e.target.checked)}
            className="w-4 h-4"
          />
          Fragile
        </label>
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={formData.requires_signature || false}
            onChange={(e) => updateField('requires_signature', e.target.checked)}
            className="w-4 h-4"
          />
          Requires Signature
        </label>
      </div>
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Delivery To You</h4>
      
      <div>
        <label className="block text-sm font-medium mb-2">Delivery Address *</label>
        <Input
          value={formData.delivery_address || ''}
          onChange={(e) => updateField('delivery_address', e.target.value)}
          placeholder="Where to deliver the item"
          required
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Delivery Instructions</label>
        <Input
          value={formData.delivery_instructions || ''}
          onChange={(e) => updateField('delivery_instructions', e.target.value)}
          placeholder="Gate code, apartment number, etc."
        />
      </div>
    </div>
  );
};

export default LocalPickupForm;
